import { api } from './api/api.js';

let curso = null;

export function obtenerCursoActivo() {
	return curso;
}

export function obtenerPeriodoAbierto() {
	for (const p of curso.periodos) {
		if (p.estado == 1) {
			return p;
		}
	}
	return null;
}

export function obtenerPeriodoActual() {
	let anterior = null;
	let p;
	for (p of curso.periodos) {
		if (p.estado == 1) {
			return p;
		}
		if (p.estado == 0) {
			return anterior ? anterior : p;
		}
		anterior = p;
	}

	return p;
}

export function cargarDatosCurso(id_curso = null) {
	let apiPromise;
	if (id_curso) {
		apiPromise = api(`/cursos/${id_curso}`);
	} else {
		apiPromise = api(`/cursos/actual`);
	}
	return apiPromise.then((data) => { curso = data.resultado; return curso; });
}

export function obtenerNiveles(seccion = null) {
	let niveles = [];
	for (const n of curso.niveles) {
		if (! seccion || n.seccion == seccion) {
			niveles.push(n);
		}
	}
	return niveles;
}

/*

export function obtenerCurso(id_curso) {
	//const curso = obtenerCursoActual();
	if (! niveles[id_curso]) {
		niveles[id_curso] = api(`/niveles/${id_curso}`)
		return api(`/niveles/${id_curso}`)
			.then((data) => {
				niveles[id_curso] = data;
				return niveles[id_curso];
			});
	} else {
		return new Promise((resolve) => {
			return resolve(niveles[id_curso]);
		});
	}
}


// TODO: Obtener de la API
let curso = {
	id: 20192020,
    periodo_actual: 202003,
	periodos: {
		201909: 'Septiembre 2019',
		201910: 'Octubre 2019',
		201911: 'Noviembre 2019',
		201912: 'Diciembre 2019',
		202001: 'Enero 2019',
		202002: 'Febrero 2019',
		202003: 'Marzo 2019',
		202004: 'Abril 2019',
		202005: 'Mayo 2019',
		202006: 'Junio 2019',
	}
}

export function obtenerCursoActual() {
	return curso;
}

export function obtenerPeriodosCursoActual() {
}

export function establecerCursoActual(nuevoCurso) {
	curso = nuevoCurso;
}




//import { obtenerCursoActual } from 'curso.js';

let niveles = {};

export function obtenerNiveles(id_curso) {
	//const curso = obtenerCursoActual();
	if (! niveles[id_curso]) {
		niveles[id_curso] = api(`/niveles/${id_curso}`)
		return api(`/niveles/${id_curso}`)
			.then((data) => {
				niveles[id_curso] = data;
				return niveles[id_curso];
			});
	} else {
		return new Promise((resolve) => {
			return resolve(niveles[id_curso]);
		});
	}
}

export function nombreNivel(id_nivel) {
}
*/
